import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import SeedreamDetailModal from './SeedreamDetailModal';

// Phase 2 i18n — translator.trans() 返回 vnode array，flatten 为 string。
// WHY: see memory/flarum-1.8-pitfalls.md 坑 B
function t(key) {
  const result = app.translator.trans(key);
  return Array.isArray(result) ? result.join('') : result;
}
function tRich(key, params) {
  return app.translator.trans(key, params || {});
}

// API 版本号 → 用户友好显示名（v0.1.0）
// 后端存的可能是 'kling' / '4.0' / '3.0' 等英文 ID，前端要 i18n
const API_VERSION_LABELS = {
  'kling': () => t('ziven-dress-up.forum.history_page.api_version_kling'),
  '4.0': 'Seedream 4.0',
  '3.0': 'Seedream 3.0'
};
const formatApiVersion = version => {
  const label = API_VERSION_LABELS[version];
  if (typeof label === 'function') return label();
  return label || version || t('ziven-dress-up.forum.history_page.api_version_unknown');
};

// 装备类型定义
const EQUIPMENT_TYPES = [{
  key: 'clothing',
  label: () => t('ziven-dress-up.forum.common.equipment_clothing')
}, {
  key: 'pants',
  label: () => t('ziven-dress-up.forum.common.equipment_pants')
}, {
  key: 'helmet',
  label: () => t('ziven-dress-up.forum.common.equipment_helmet')
}, {
  key: 'boots',
  label: () => t('ziven-dress-up.forum.common.equipment_boots')
}, {
  key: 'gloves',
  label: () => t('ziven-dress-up.forum.common.equipment_gloves')
}, {
  key: 'goggles',
  label: () => t('ziven-dress-up.forum.common.equipment_goggles')
}, {
  key: 'snowboard',
  label: () => t('ziven-dress-up.forum.common.equipment_snowboard')
}, {
  key: 'backpack',
  label: () => t('ziven-dress-up.forum.common.equipment_backpack')
}];
export default class SeedreamHistoryPage extends Page {
  constructor() {
    super(...arguments);
    // v0.4.14: 跟 SeedreamPage 一致, bodyClass 写到 #app 隔离 ziven-dress-up 路由范围
    // 修复 v0.4.0 round 2 fix 漏修的回归: /dressUp/history 路由下 #app 没有 App--dress-up
    // → body 紫 amber 渐变失效, Flarum 默认 rgb(33,33,33) 露出
    _defineProperty(this, "bodyClass", 'App--dress-up');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.history = [];
    this.loading = true;
    this.page = 1;
    this.totalPages = 1;
    this.deletingId = null; // 正在删除的记录ID
    this.regeneratingId = null; // 正在重新生成的记录ID
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.loadHistory();
  }
  async loadHistory() {
    this.loading = true;
    m.redraw();
    try {
      const response = await app.request({
        method: 'GET',
        url: '/api/ziven/seedream/history',
        params: {
          page: this.page
        }
      });
      if (response.success) {
        var _response$data$pagina;
        this.history = response.data.records || [];
        this.totalPages = ((_response$data$pagina = response.data.pagination) == null ? void 0 : _response$data$pagina.total_pages) || 1;
      }
    } catch (error) {
      console.error('Failed to load history:', error);
    }
    this.loading = false;
    m.redraw();
  }
  view() {
    return m("div", {
      class: "SeedreamHistoryPage",
      style: {
        overflow: 'visible',
        minHeight: '100vh'
      }
    }, m("div", {
      class: "seedream-container"
    }, m("div", {
      class: "history-header"
    }, m("h2", {
      class: "seedream-title"
    }, m("i", {
      class: "fas fa-history"
    }), ' History'), m(Button, {
      class: "btn-glass",
      onclick: () => m.route.set('/dressUp')
    }, m("i", {
      class: "fas fa-arrow-left"
    }), t('ziven-dress-up.forum.history_page.back_to_fusion'))), this.loading ? m("div", {
      class: "loading-area"
    }, m(LoadingIndicator, null), m("span", null, t('ziven-dress-up.forum.common.loading'))) : this.history.length === 0 ? m("div", {
      class: "history-empty"
    }, m("i", {
      class: "fas fa-inbox"
    }), m("p", null, t('ziven-dress-up.forum.history_page.empty')), m(Button, {
      class: "btn-amber",
      onclick: () => m.route.set('/dressUp')
    }, m("i", {
      class: "fas fa-magic"
    }), t('ziven-dress-up.forum.history_page.start_fusion_now'))) : m("div", {
      class: "history-grid"
    }, this.history.map(record => m("div", {
      class: "history-card glass-card",
      key: record.id
    }, m("div", {
      class: "history-card-thumbnail"
    }, this.getStatusKey(record) === 'failed' || !record.result_image_url ?
    // v0.4.8: 失败任务无图时显示统一占位,避免空 src 触发浏览器破图
    m("div", {
      class: "history-card-failed-placeholder",
      onclick: () => this.openModal(record),
      role: "button",
      "aria-label": t("ziven-dress-up.forum.history_page.failed_click_details")
    }, m("i", {
      class: "fas fa-times-circle"
    }), m("span", null, t('ziven-dress-up.forum.history_page.generation_failed'))) : m("img", {
      src: record.result_image_url,
      alt: "Result",
      onclick: () => this.openModal(record),
      style: {
        cursor: 'pointer'
      },
      loading: "lazy"
    }), m("span", {
      class: "status-tag status-".concat(this.getStatusKey(record))
    }, m("i", {
      class: this.getStatusIcon(record)
    }), this.getStatusText(record)), record.status === 0 ? this.isStuck(record) ? m("div", {
      class: "stuck-overlay"
    }, m("i", {
      class: "fas fa-exclamation-triangle"
    }), m("span", null, t('ziven-dress-up.forum.history_page.generation_timeout')), m("button", {
      class: "delete-btn",
      onclick: () => this.deleteRecord(record.id),
      disabled: this.deletingId === record.id,
      title: t("ziven-dress-up.forum.history_page.delete")
    }, this.deletingId === record.id ? m("i", {
      class: "fas fa-spinner fa-spin"
    }) : m("i", {
      class: "fas fa-trash"
    }))) : m("div", {
      class: "generating-overlay"
    }, m(LoadingIndicator, {
      size: "small"
    }), m("span", null, t('ziven-dress-up.forum.history_page.generating'))) : m("div", {
      class: "history-actions"
    }, m("button", {
      class: "regenerate-btn",
      onclick: () => this.regenerateRecord(record.id),
      disabled: this.regeneratingId === record.id,
      title: t("ziven-dress-up.forum.history_page.regenerate")
    }, this.regeneratingId === record.id ? m("i", {
      class: "fas fa-spinner fa-spin"
    }) : m("i", {
      class: "fas fa-redo"
    })), m("button", {
      class: "delete-btn",
      onclick: () => this.deleteRecord(record.id),
      disabled: this.deletingId === record.id,
      title: t("ziven-dress-up.forum.history_page.delete")
    }, this.deletingId === record.id ? m("i", {
      class: "fas fa-spinner fa-spin"
    }) : m("i", {
      class: "fas fa-trash"
    })))), m("div", {
      class: "history-info"
    }, m("span", {
      class: "history-card-title"
    }, formatApiVersion(record.api_version)), m("span", {
      class: "created-at"
    }, m("i", {
      class: "fas fa-clock"
    }), this.formatDate(record.created_at)), m("span", {
      class: "api-version"
    }, m("i", {
      class: "fas fa-cog"
    }), formatApiVersion(record.api_version)))))), !this.loading && this.totalPages > 1 && m("div", {
      class: "pagination"
    }, m(Button, {
      class: "btn-page",
      disabled: this.page <= 1,
      onclick: () => this.changePage(this.page - 1)
    }, m("i", {
      class: "fas fa-chevron-left"
    })), m("span", {
      class: "page-info"
    }, this.page, " / ", this.totalPages), m(Button, {
      class: "btn-page",
      disabled: this.page >= this.totalPages,
      onclick: () => this.changePage(this.page + 1)
    }, m("i", {
      class: "fas fa-chevron-right"
    })))));
  }

  // v0.4.0 Phase 2 批 2B-5: status tag 3 状态辅助方法
  getStatusKey(record) {
    if (record.status === 0) return this.isStuck(record) ? 'stuck' : 'processing';
    if (record.status === 1) return 'success';
    if (record.status === 2) return 'failed';
    return 'unknown';
  }
  getStatusIcon(record) {
    const key = this.getStatusKey(record);
    return {
      'success': 'fas fa-check-circle',
      'processing': 'fas fa-spinner fa-spin',
      'stuck': 'fas fa-exclamation-triangle',
      'failed': 'fas fa-times-circle',
      'unknown': 'fas fa-question-circle'
    }[key] || 'fas fa-question-circle';
  }
  getStatusText(record) {
    const key = this.getStatusKey(record);
    return {
      'success': t('ziven-dress-up.forum.history_page.status_completed'),
      'processing': t('ziven-dress-up.forum.history_page.status_generating'),
      'stuck': t('ziven-dress-up.forum.history_page.status_timeout'),
      'failed': t('ziven-dress-up.forum.history_page.status_failed'),
      'unknown': t('ziven-dress-up.forum.history_page.status_unknown')
    }[key] || t('ziven-dress-up.forum.history_page.status_unknown');
  }
  async openModal(record) {
    // 直接打开详情弹窗，让弹窗自己去获取完整数据
    app.modal.show(SeedreamDetailModal, {
      record: record,
      onDeleted: id => {
        // 从列表中移除
        this.history = this.history.filter(r => r.id !== id);
        m.redraw();
      },
      onRegenerated: () => {
        // 刷新历史列表
        this.loadHistory();
      }
    });
  }
  changePage(page) {
    this.page = page;
    this.loadHistory();
  }
  async deleteRecord(id) {
    if (this.deletingId) return; // 防止重复删除

    if (!confirm(t('ziven-dress-up.forum.history_page.delete_confirm'))) {
      return;
    }
    this.deletingId = id;
    m.redraw();
    try {
      const response = await app.request({
        method: 'DELETE',
        url: '/api/ziven/seedream/history/' + id
      });
      if (response.success) {
        // 从列表中移除
        this.history = this.history.filter(record => record.id !== id);
      } else {
        alert(response.error || t('ziven-dress-up.forum.history_page.delete_failed'));
      }
    } catch (error) {
      console.error('Failed to delete record:', error);
      alert(t('ziven-dress-up.forum.history_page.delete_failed_retry'));
    }
    this.deletingId = null;
    m.redraw();
  }
  async regenerateRecord(id) {
    if (this.regeneratingId) return; // 防止重复请求

    if (!confirm(t('ziven-dress-up.forum.history_page.regenerate_confirm'))) {
      return;
    }
    this.regeneratingId = id;
    m.redraw();
    try {
      const response = await app.request({
        method: 'POST',
        url: '/api/ziven/seedream/regenerate/' + id
      });
      if (response.success) {
        // 显示成功消息
        if (response.data.task_id) {
          // 异步任务
          alert(t('ziven-dress-up.forum.history_page.regenerate_task_created'));
        } else if (response.data.image_url) {
          // 同步返回图片
          alert(t('ziven-dress-up.forum.history_page.regenerate_success'));
          // 刷新历史列表
          this.loadHistory();
        }
      } else {
        alert(response.error || t('ziven-dress-up.forum.history_page.regenerate_failed'));
      }
    } catch (error) {
      console.error('Failed to regenerate record:', error);
      alert(t('ziven-dress-up.forum.history_page.regenerate_failed_retry'));
    }
    this.regeneratingId = null;
    m.redraw();
  }
  isStuck(record) {
    if (record.status !== 0) return false;
    if (!record.created_at) return false;
    const created = new Date(record.created_at);
    const now = new Date();
    const minutesOld = (now - created) / 1000 / 60;
    return minutesOld > 10;
  }
  formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}
flarum.reg.add('ziiven-dress-up', 'forum/components/SeedreamHistoryPage', SeedreamHistoryPage);